/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Tag from './Tag';
import { tagFetch } from '../../actions/tag';
import { fetchHotWords } from '../../actions/search';
import { trackEventLog } from '../../core/utils'

async function action({ store, params }) {
  trackEventLog(`/w/tag/${params.id}`)
  await store.dispatch(tagFetch(params.id));
  await store.dispatch(fetchHotWords(params.id))
  if (process.env.BROWSER && window.NProgress) {
    window.NProgress.done()
  }
  return {
    chunks: ['tag'],
    title: `${store.getState().tag.name}-有道精品课-为你精选好课`,
    component: <Tag />,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/tag/index.js